export default "__VITE_ASSET__DfZf9KtO__"